export const delay = (afterDelay, timer) => {
  const modalTimeout = setTimeout(afterDelay, timer);
  return () => clearTimeout(modalTimeout);
};
